module.exports = __webpack_public_path__ + "assets/img/38_421_big.3ab6827b.jpg";